const _ = require('lodash');

function isEmailAddress (value) {
  return _.isString(value) && /^[^@]+@[^@]+\.[^@]+$/.test(value)
}

module.exports = isEmailAddress;
